/* eslint-disable max-lines-per-function */
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { AbsatzVorgabe } from '@/domain/controlling/entities';
import { AbsatzProduktivitaetWithAbsatzVorgabeOptions } from './AbsatzProduktivitaetWithAbsatzVorgabeOptions';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import {
  EinstellungenUpdateForm,
  EinstellungenUpdateFormSchema,
} from '../types';
import { useTranslation } from 'react-i18next';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function AbsatzProduktivitaetForm({
  form,
  onSubmit,
}: {
  form: EinstellungenUpdateForm;
  onSubmit(data: EinstellungenUpdateFormSchema): void;
}) {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { tagebuchEinstellungen } = useTagebuchEinstellungen(standortId);
  const { t } = useTranslation();

  return (
    <Form key="umsatzplanungEinstellungenForm" {...form}>
      <form
        id="umsatzplanungEinstellungenForm"
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-2">
        <FormField
          control={form.control}
          name="zielProduktivitaetAbsatz"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t(
                  'domain.controlling.umsatzplanung.einstellungen.inputs.zielProduktivitaetAbsatz.label',
                )}
              </FormLabel>
              <FormControl>
                <AbsatzProduktivitaetWithAbsatzVorgabeOptions
                  isValid={
                    !form.getFieldState('zielProduktivitaetAbsatz').invalid
                  }
                  onInput={(e) => {
                    form.setValue(
                      'zielProduktivitaetAbsatz.value',
                      e.currentTarget.value,
                    );
                  }}
                  onOptionsChange={(value: AbsatzVorgabe) => {
                    form.setValue('zielProduktivitaetAbsatz.unit', value);
                  }}
                  onBlur={() => form.trigger()}
                  defaultOption={
                    tagebuchEinstellungen.absatzProduktivitaet.absatzVorgabe
                  }
                  defaultInputValue={field.value.value}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
